import { useEffect } from 'react';
import BRAND from './brand';
import { showConfirm } from './platform';

const DISMISSED_VERSION_KEY = 'stems_dismissed_version';
const CURRENT_VERSION_KEY = 'stems_current_version';

export const useAppVersion = () => {
  useEffect(() => {
    // Не проверяем версию на админ панели
    if (window.location.pathname.startsWith('/admin')) {
      return;
    }

    const checkVersion = async () => {
      try {
        const response = await fetch('/version.json?t=' + Date.now());
        const data = await response.json();

        // Сохраняем текущую версию при первой загрузке
        const currentVersion = localStorage.getItem(CURRENT_VERSION_KEY);
        if (!currentVersion) {
          localStorage.setItem(CURRENT_VERSION_KEY, data.version);
          return;
        }

        // Проверяем, не отклонил ли пользователь уже это обновление
        const dismissedVersion = localStorage.getItem(DISMISSED_VERSION_KEY);

        // Показываем уведомление только если версия изменилась с момента последнего визита
        if (data.version !== currentVersion && data.version !== dismissedVersion) {
          showConfirm(
            BRAND.updateAlert,
            (confirmed) => {
              if (confirmed) {
                localStorage.setItem(CURRENT_VERSION_KEY, data.version);
                localStorage.removeItem(DISMISSED_VERSION_KEY);
                window.location.reload(true);
              } else {
                localStorage.setItem(DISMISSED_VERSION_KEY, data.version);
                setTimeout(() => {
                  localStorage.removeItem(DISMISSED_VERSION_KEY);
                }, 5 * 60 * 1000);
              }
            }
          );
        }
      } catch (error) {
        console.error('Version check failed:', error);
      }
    };

    // Проверяем ТОЛЬКО при запуске приложения: периодическая проверка могла
    // показать окно «обновитесь» посреди оформления заказа
    checkVersion();
  }, []);
};
